module.exports = __webpack_public_path__ + "img/avb@2x.697e7b5.webp";